module.exports = __webpack_public_path__ + "assets/img/The-Onset-Website-w960.c3c7a77c.webp";